import React from "react";
import {Theme} from '@mui/material/styles';
import {Button, useTheme} from "@mui/material";
import {palette} from "../../technical/style/theme";
import {SxProps} from "@mui/system";

export function PrimaryButton(props: {
  onClick?: () => void,
  title?: string,
  sx?: SxProps<Theme>,
  /**
   * Element placed before the children.
   */
  startIcon?: React.ReactNode,
  disabled?: boolean,
  type?: "button" | "submit",
  /**
   * If `true`, no elevation is used.
   */
  disableElevation?: boolean,
}) {
  const theme = useTheme();
  const sx = {
    minWidth: 150,
    [theme.breakpoints.down('sm')]: {
      minWidth: 100,
    },
    '&:hover': {
      background: theme.palette.secondary.light,
    },
    '&:not([disabled])': {
      background: palette.primary,
      color: theme.palette.background.default,
    }
  };
  return (
    <Button size={'medium'} startIcon={props.startIcon} sx={{...props.sx, ...sx}}
            onClick={props.onClick} disabled={props.disabled} type={props.type || "button"} disableElevation={props.disableElevation}>
      {props.title}
    </Button>
  );
}
